import React, { memo, MouseEventHandler, ReactNode } from 'react'
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons'
import { Button, iconStyles, ButtonColor } from './Button'

interface Props {
  text?: string
  color?: ButtonColor
  icon?: ReactNode
  className?: any
  selected?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  dataTestId?: string
}

const ActionButtonComponent = ({
  text,
  icon,
  color = 'primary',
  className,
  selected,
  loading,
  disabled,
  onClick,
  dataTestId,
}: Props) => (
  <Button
    variant="contained"
    size="small"
    color={color}
    loading={loading}
    className={className}
    selected={selected}
    disabled={disabled}
    onClick={onClick}
    {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    leftIcon={icon}
    rightIcon={
      selected ? (
        <CaretUpMinor width={20} css={iconStyles[color]} />
      ) : (
        <CaretDownMinor width={20} css={iconStyles[color]} />
      )
    }
  >
    {text}
  </Button>
)

export const ActionButton = memo(ActionButtonComponent)
